<template>
<div class="viewContainer">
  <div v-if="caseing">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="案例名称：" style="width:30%;display:flex">
            <el-input v-model="expName" placeholder="请输入案例名称" maxlength="20" style="width:90%"/>
          </el-form-item>
          <!-- <el-form-item label="商品编码：">
            <el-input style="width:400px;" v-model="goodsCode" placeholder="请输入商品编码" maxlength="30"></el-input>
          </el-form-item>-->
          
          <el-form-item label="状　　态：" style="width:30%;display:flex">
            <el-select v-model="zhuangtaiid" placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in statusarr" :key="index" :value="item.Id" :label="item.Name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="装修风格：" label-width="45px" style="width:30%;display:flex">
            <el-select v-model="zffgid" placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in shoptype" :key="index" :value="item.Id" :label="item.Name"/>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form class="findform">
          <el-form-item label="户　　型：" style="width:30%;display:flex">
            <!-- <el-select style="width:240px;" v-model="decorationType" placeholder="请选择">
              <el-option v-for="(item,index) in decarr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>-->
            <el-cascader :value="decorationType" :options="optionshx" @change="handlehx" style="width:90%"/>
          </el-form-item>
          <el-form-item label="所属店铺：" style="width:30%;display:flex">
            <el-select v-model="suoshudp" placeholder="请选择" filterable style="width:90%">
              <el-option v-for="(item,index) in dianpuArr" :key="index" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="设计师名称：" label-width="45px" style="width:30%;display:flex">
            <el-input v-model="sjsName" placeholder="请输入设计师名称" maxlength="20" style="width:90%"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="findinfo()" style="float:right;">查 询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">装修案例</p>
        <el-button type="danger" @click="addeditinfo('')" style="float: right;margin: 5px 10px 0 0;">新 增</el-button>
      </section>
      <div class="table_container">
      <el-table :data="goodListInfo" stripe border>
        <el-table-column label="序号" type="index" width="60" align="center"/>
        <el-table-column label="所属店铺" align="center">
          <template scope="scope"><span class="spanList">{{scope.row.shopName}}</span></template>
        </el-table-column>
        <el-table-column label="设计师" align="center">
          <template scope="scope">{{scope.row.designerName}}</template>
        </el-table-column>
        <el-table-column label="案例标题" align="center">
          <template scope="scope">{{scope.row.expName}}</template>
        </el-table-column>
        <el-table-column label="风格" align="center" width="100">
          <template scope="scope">{{scope.row.styleName}}</template>
        </el-table-column>
        <el-table-column label="装修类型" align="center" width="100">
          <template scope="scope">{{scope.row.workTypeName}}</template>
        </el-table-column>
        <el-table-column label="户型" align="center" width="100">
          <template scope="scope">{{scope.row.domain}}</template>
        </el-table-column>
        <el-table-column label="面积" align="center" width="100">
          <template scope="scope">{{scope.row.expSize}}</template>
        </el-table-column>
        <el-table-column label="费用" align="center" width="100">
          <template scope="scope">{{scope.row.expPrice}}</template>
        </el-table-column>
        <el-table-column label="施工工期" align="center" width="100">
          <template scope="scope">{{scope.row.expWorkDay}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100">
          <template scope="scope">{{scope.row.onlineStatus}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="200">
          <template scope="scope">
            <!-- <a href="javascript:;" class="ahref" @click="editinfo(scope.row)">编辑</a> -->
            <span @click="addeditinfo(scope.row)" class="handle">
              <i class="el-icon-edit-outline"></i> 编辑
            </span>
            <!-- <a href="javascript:;" @click="onshop(scope.row)" class="ahref">{{scope.row.isOnline == 0?"上架":"下架"}}</a>-->
            <span @click="onshop(scope.row)" class="handle">
              <i :class="scope.row.isOnline == 0?'el-icon-upload2':'el-icon-download'"/>
              {{scope.row.isOnline == 0?'上架':'下架'}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin: 10px 0;"/>
      </div>
    </div>
  </div>
  <!-- 详情页面 -->
  <div v-else class="main_container" v-loading="loading2" element-loading-text="拼命保存中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
    <h2 class="shopTitle">{{showtype == 1?"新增案例":"编辑案例"}}</h2>
    <div class="domDiv">
      <p class="xmxx"> 项目信息 </p>
      <div class="contentDiv">
        <el-form class="demoFormInline">
          <!-- <el-form-item class="selectflex" label="作品名称：">
            <el-input v-model="ExpName" @blur="zishu" placeholder="请输入案例标题（1-20字之间）"
              style="width: 90%;" maxlength="20"/>
          </el-form-item> -->
          <el-form-item class="selectflex" label="作品分类：">
            <!-- <el-select
              v-model="zpflid"
              @change="decchange()"
              style="width:47%;"
              placeholder="请选择分类">
              <el-option
                v-for="(item,index) in decarr"
                :key="index"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
            <el-select v-model="zpflhxid"   style="width:47%;margin-left:7%" placeholder="请选择分类">
              <el-option
                v-for="(item,index) in smallarr"
                :key="index"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select> -->
            <el-cascader v-model="casaarr" style="width:90%" :options="optionszpfl" @change="handlezpfl"/>
          </el-form-item>
          <el-form-item class="selectflex" label="设计师：">
            <el-select v-model="sjsid" placeholder="请选择" style="width: 90%;">
              <el-option v-for="(item,index) in sjsArr" :key="index" :value="item.designerid" :label="item.designername"/>
            </el-select>
            <!-- 　(选填) -->
          </el-form-item>
        </el-form>
        <el-form class="demoFormInline">
          <el-form-item class="selectflex" label="作品风格：">
            <el-select v-model="zpfgid"  placeholder="请选择" style="width: 90%;">
              <el-option v-for="(item,index) in shoptype" :key="index" :value="item.Id" :label="item.Name"/>
              </el-select>
          </el-form-item>
          <el-form-item class="selectflex" label="面　　积：">
            <el-input v-model="ExpSize" class="slotwidth" style="width:90%" @blur="ExpSizeblur()"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              placeholder="单行输入" maxlength="8"> <template  slot="append">㎡</template></el-input>
          </el-form-item>
        </el-form>
        <el-form class="demoFormInline">
          <!-- <span style="margin-top:11px;display: inline-block;margin-left:-8px;white-space: nowrap;">平米</span> -->
          <!-- <el-form-item class="selectflex" label="费用：">
            <el-input v-model="ExpPrice" style="width:100%" @blur="ExpSizeblur()"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              placeholder="单行输入" maxlength="8"><template slot="append">元</template></el-input>
          </el-form-item> -->
        
          <el-form-item class="selectflex" label="工　　期：">
            <el-input v-model="ExpWorkDay" style="width:90%" class="slotwidth" @blur="ExpSizeblur()"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')" placeholder="单行输入"
              maxlength="8"><template slot="append">天</template></el-input>
          </el-form-item>
          <!-- <span style="margin-top:11px;display: inline-block;margin-left:-8px">天</span> -->
          <el-form-item class="selectflex" label="工程造价：">
            <el-input v-model="ExpWorkPrice" style="width:90%" @blur="ExpSizeblur()"
              onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              placeholder="单行输入" maxlength="8">   <template slot="append">万元</template></el-input>
          </el-form-item>
        </el-form>
        <el-form class="demoFormInline">
          <el-form-item class="selectflex" label="所属城市：">
            <el-cascader v-model="selectedOptions" placeholder="请选择城市" :options="optionssscs"
              style="width:90%" filterable @change="handlesscs"/>
          </el-form-item>
          <el-form-item class="selectflex" label="小区名称：">
            <el-input v-model="ExpAddress" maxlength="20" placeholder="请输入小区名称" style="width: 90%;"/>
          </el-form-item>
        </el-form>
        <el-form class="demoFormInline">
          <!-- <span style="margin-top:11px;display: inline-block;margin-left:-8px">元</span> -->
          <el-form-item class="selectflex" label="施工方式：">
            <el-select v-model="ExpWorkType"  placeholder="请选择施工方式 " style="width: 90%;">
              <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in stylearr" :key="index"/>
            </el-select>
          </el-form-item>
          <el-form-item class="selectflex" label="业主手机：">
            <el-input v-model="yezhuPhone" maxlength="11" placeholder="请输入业主手机号码" style="width: 90%;"/>
          </el-form-item>
        </el-form>
        <el-form class="demoFormInline">
          <el-form-item class="selectflex" label="案例封面：">
            <!-- <div class="multigraph" v-for="(item,index) in detailImgUrlarr" :key="index" :data-img="item">
              <el-image style="width: 100px; height:60px" :src="item"/>
              <div class="chahao" @click.stop="deldetail(index)">
                <img src="../../assets/img/aicon36.png"/>
              </div>
            </div> -->
            <!-- <el-upload class="avatar-uploader" action multiple v-if="flag < 3"
              accept=".png, .jpg, .jpeg" :show-file-list="false" :before-upload="beforeAvatarUpload">
              <img style="width:100px;height:60px;" v-if="imageUrl" :src="imageUrl" class="avatar"/>
              <i class="el-icon-plus avatar-uploader-icon" v-for="index of uploadArr" :key="index" v-show="seeIflag"/>
            </el-upload>
            <div style="color:#888;display:inline-block;">建议尺寸：1200*675，支持的图片格式：jpg、png。</div> -->
            <div style="display:flex;flex-wrap:wrap">
            <div v-for="(item,index) in imgShopArr" :key="index" style="display:inline-block; position: relative;">
              <img src="../../assets/img/aicon36.png" @click="deleteimg(index,item)" style="position:absolute;right:7px;top:-8px;width: 20px;"/>
              <img :src="item" style="width:80px;height:80px;display:inline-block;margin-right:15px;"/>
            </div>
            <div class="upload" style="display:inline-block;" v-show="imgShopArr.length<5">
              <el-upload v-show="isdisabled" style action :show-file-list="false" :before-upload="beforeUploadShopIntroduction">
                <img :src="zstpUrl" v-if="zstpUrl" style="width:80px;height:80px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"/>
              </el-upload>
            </div>
            </div>
            <div style="color:#888;">建议上传图片尺寸为1:1，最多上传5张。</div>
          </el-form-item>
          <el-form-item class="selectflex" label="视频(选填)：">
            <div v-if="videoSrc" class="videoClass">
              <span @click="newSeevideo(videoSrc)" class="previewingVideo">
                <img :src="videoImg" v-if="videoImg">
                <img src="../../assets/img/spfm.png" v-else>
                <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
              </span>
              <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
            </div>
            <el-upload v-else class="avatar-uploader-zstp" action="" accept="video/*" :before-upload="handleFile">
              <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"/>
            </el-upload>
            <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
          </el-form-item>
        </el-form>
      </div>

      <p class="xmxx"> 主要使用建材 </p>
      <div class="contentDiv">
        <el-form class="demoFormInline">
          <el-form-item class="selectflex" label="建材品类：">
            <el-select v-model="BrandTypeId" style="width:90%" placeholder="请选择"
              @visible-change="choiceBrandtype" @change="changeBrand">
              <el-option v-for="(item,index) in brandTypelist" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
          <el-form-item class="selectflex" label="建材品牌：">
            <el-select v-model="BrandId" style="width:90%;" placeholder="请选择"
              @visible-change="choiceBrand" @change="changeBra">
              <el-option v-for="(item,index) in brandListarr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" :border="bordersure" style="width: 90%;">
          <el-table-column align="center" label="品类">
            <template scope="scope">
              <span :title="scope.row.brandTypeName">{{scope.row.brandTypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="品牌">
            <template scope="scope">
              <span :title="scope.row.brandName">{{scope.row.brandName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="使用场景">
            <template scope="scope">
              <span :title="scope.row.useScene">{{scope.row.useScene}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template scope="scope">
              <a href="javascript:;" class="ahref" @click="shanchu(scope)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <el-form class="demoFormInline">
          <el-form-item class="selectflex" label="使 用 场 景：">
            <el-input type="textarea" v-model="changjing" style="width:80%" maxlength="50" show-word-limit/>
            <el-button type="danger" @click="addinfo()">增加</el-button>
          </el-form-item>
          <el-form-item class="selectflex"/>
        </el-form>
      </div>

      <p class="xmxx"> 案例介绍 </p>
      <div class="contentDiv">
        <!-- <el-upload class="avatar-uploaderfu" action="serverUrl" name="img" :show-file-list="false" :before-upload="beforeUpload"/> -->
        <!--富文本编辑器组件-->
        <wjEditor :desc="ExpIntroduce" @change="contentChangeOne" style="width:90%;"/>
        <!-- <quill-editor ref="text" v-model="ExpIntroduce" :options="editorOption" style="margin-left:30px" class="myQuillEditor"/>-->
        <!-- <quill-editor v-model="ExpIntroduce" ref="myQuillEditor" :options="editorOption"></quill-editor> -->
      </div>
      
      <p class="xmxx"> 本内容由我原创 </p>
      <div class="contentDiv">
        <div class="youwo">
          <span> <el-switch v-model="value2" active-color="#F56C6C" inactive-color="#ddd"/> </span>
          <p>本人承诺本人账户中所上传的全部作品均系本人自主创作形成的原创内容，拥有合法有效、独立完整的著作权，不侵犯任何第三人的合法权益</p>
        </div>
        
        <!-- 写作小贴士 -->
        <div>
          <p style="font-size:16px;font-weight:600;color:#ffc500;">写作小贴士</p>
          <p style="font-weight:600;color:#888;">A.关于前言，你可以说说</p>
          <p>
            <span class="rideo"></span>
            <span style="color:#bcbbba">装修背后的故事</span>
          </p>
          <p style="margin-top:-10px">
            <span class="rideo"></span>
            <span style="color:#bcbbba">为什么选择这种装修风格</span>
          </p>
          <p style="margin-top:-10px">
            <span class="rideo"></span>
            <span style="color:#bcbbba">装修前要注意那些事项</span>
          </p>
          <p style="font-weight:600;color:#888;">B.正文部分，有以下小Tips</p>
          <p style="display:flex">
            <span style="margin-top:8px" class="rideo"></span>
            <span style="color:#bcbbba">介绍装修的基本信息（包括户型图、面积、装修费用、装修及入住时长等）</span>
          </p>
          <p style="margin-top:-10px;display:flex">
            <span style="margin-top:8px" class="rideo"></span>
            <span style="color:#bcbbba">说说每个空间当初事怎么设计/布置的，为什么这样做</span>
          </p>
          <p style="margin-top:-10px;display:flex">
            <span style="margin-top:8px" class="rideo"></span>
            <span style="color:#bcbbba">你也可以拖拽效果图模板调整段落顺序</span>
          </p>
          <p style="margin-top:-10px;display:flex">
            <span style="margin-top:8px" class="rideo"></span>
            <span style="color:#bcbbba">大场景照喝丰富文字描述将会是你的方案更受欢迎</span>
          </p>
          <p style="font-weight:600;color:#888;">C.在最后，你还可以分享</p>
          <p>
            <span class="rideo"></span>
            <span style="color:#bcbbba">完工后业主的看法</span>
          </p>
          <p style="margin-top:-10px">
            <span class="rideo"></span>
            <span style="color:#bcbbba">这次装修留下的遗憾</span>
          </p>
          <p style="margin-top:-10px">
            <span class="rideo"></span>
            <span style="color:#bcbbba">想要给大家的建议/忠告</span>
          </p>
        </div>
      </div>

    </div>
    <div class="gudingdibu">
      <el-button @click="close()">取消</el-button>
      <el-button type="danger" @click="emit()" :loading="loadingBut">{{loadingButText}}</el-button>
    </div>
  </div>
  <!-- 上架弹框 -->
  <el-dialog title="提示" :visible.sync="dialogVisiblesure" width="30%">
    <span>{{showtype==0?"您确定上架此商品吗?":"您确定下价架此商品吗?"}}</span>
    <span slot="footer" class="dialog-footer">
      <div style="text-align:center">
        <el-button @click="dialogVisiblesure = false">取消</el-button>
        <el-button type="danger" @click="makesure()">确定</el-button>
      </div>
    </span>
  </el-dialog>
  <!-- 上架弹框 -->
  <el-dialog title="提示" :visible.sync="dialogVisiblesure" width="30%">
    <span>{{isOnline == 0?"是否上架当前案例":"是否下架当前案例"}}</span>
    <span slot="footer" class="dialog-footer">
      <div style="text-align:center">
        <el-button @click="dialogVisiblesure = false">取消</el-button>
        <el-button type="danger" @click="makesure()">确定</el-button>
      </div>
    </span>
  </el-dialog>
  <!-- 播放视频 -->
  <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
  <!-- 选择装修公司 -->
  <el-dialog title="选择装修公司" :visible.sync="dialogVisibleadd" width="25%" center>
    <el-form>
      <el-form-item label="装修公司：" style="display:flex;">
        <el-select v-model="companyId" filterable placeholder="请选择装修公司" style="width: 90%;">
          <el-option v-for="item in zxgsArr" :key="item.shopid" :label="item.shopname" :value="item.shopid"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleadd = false">取消</el-button>
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import wjEditor from '../../components/MyWangEditor';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, provincegetcountys, uploadVedio, userIdentity } from '../../api/newOss';
import { getkind, SelectGoodsBrandTypeByFirstLetter, EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType,
  SelectDesignerSkilledDoMainBaseData, UpoadImg } from "../../api/api";
import { getshoplist, postgetlist, getzxalinfo, postsavezxal, designergetlist } from "../../api/shopWindow";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"] // remove formatting button
];
export default {
  name: "decorationCases",
  mixins: [alertTrends],
  components: { wjEditor },
  data() {
    return {
      shopId: '', // 店铺id
      listid: '', // 列表选中行id
      suoshudp: '', // 所属店铺
      dianpuArr: [],
      selectedOptions: [],
      provinceId: 0,
      cityId: 0,
      optionssscs: [], // 所属城市
      casaarr:[],
      show3: true,
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      ExpIntroduce: "", // 富文本内容

      editorOption: {
        placeholder: "",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector(".avatar-uploaderfu input").click();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      },
      showtype: 1,
      changjing: "",
      smallarr: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      bordersure: true,
      branName: "",
      branName1: "",
      styleheight: "100px",
      zpflid: -1, // 作品分类
      zpflhxid: 0, // 作品分类-户型
      sjsid: 0, // 设计师
      sjsArr: [], // 设计师集合
      zpfgid: 0, // 作品风格
      shoptype: [], // 作品风格集合
      imageUrl: "",
      detailImgUrlarr: [], // 多图集合
      flag: 0,
      uploadArr: 3,
      seeIflag: true,
      ExpSize: "",
      ExpAddress: "",
      ExpIntroduce: "",
      BuildingMaterialStr: "",
      ExpWorkDay: "",
      ExpWorkType: 0,
      yezhuPhone: '', // 业主手机
      loading2: false,
      ExpWorkPrice: "",
      ExpPrice: "",
      ExpName: "",
      dialogVisiblesure: false,
      value2: true,
      expName: "", // 案例名称
      sjsName: '', // 设计师名称
      zhuangtaiid: -1, // 状态id
      statusarr: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 0,
          Name: "已下架"
        },
        {
          Id: 1,
          Name: "已上架"
        }
      ],
      zffgid: 0, // 装修风格
      brandList: [],
      tableData: [],
      firstLetterType: 0,
      brandTypelist: [
        {
          Id: 0,
          Name: "请选择"
        }
      ],
      brandListarr: [
        {
          Id: 0,
          Name: "请选择"
        }
      ],
      BrandTypeId: 0,
      isOnline: -1, // 状态 0=下架 1=上架
      decorationType: -1, // 装修类型
      houseType: 0, // 户型
      optionshx: [
        {
          value: -1,
          label: "全部"
        },
        {
          value: 0,
          label: "家装",
          children: []
        },
        {
          value: 1,
          label: "公装",
          children: []
        }
      ],
      decarr: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 0,
          Name: "家装"
        },
        {
          Id: 1,
          Name: "公装"
        }
      ],
      BrandId: 0,
      firstChoice: 0,
      checkedbiddingId: "",
      caseing: true,
      goodListInfo: [],
      type: 0,
      dialogVisiblesure: false,
      total: 10,
      pageIndex: 1,
      stylearr: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      jiaarr: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      gongarr: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      imgShopArr: [], // 案例图片
      onePic: [],
      isdisabled: true,
      zstpUrl: '', // 展示图片
      formInline: {},
      optionszpfl: [
        {
          value: -1,
          label: "全部"
        },
        {
          value: 0,
          label: "家装",
          children: []
        },
        {
          value: 1,
          label: "公装",
          children: []
        }
      ],
      
      videoImg: '', // 视频封面图
      videoSrc: "", // 全连接
      videoShortSrc: "", // 切割之后链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      
      dialogVisibleadd:false, // 选择装修公司
      companyId:"",
      zxgsArr:[],
      
      loadingBut: false,
      loadingButText: '确定',
      
    };
  },
  methods: {
    // 案例介绍
    contentChangeOne(content) {
      this.ExpIntroduce = content;
    },
    // 重置
    fnReset() {
      this.expName = "";
      this.zhuangtaiid = -1;
      this.zffgid = 0;
      this.decorationType = -1;
      this.suoshudp = '';
      this.sjsName = '';
    },
    // 列表
    init() {
      var obj = {
        userid: localStorage.Id, // 当前用户ID
        expname: this.expName, // 案例名称
        status: this.zhuangtaiid, // 案例状态 -1=全部 0=下架 1=上架
        styleid: this.zffgid, // 装修风格ID
        experiencetypeid: Number(this.decorationType), // 装修类型 -1=全部 0=家装 1=公装
        domainid: this.houseType, // 户型ID
        shopid: this.suoshudp, // 店铺ID
        designername: this.sjsName, // 设计师名称
        pageindex: this.pageIndex,
        pagesize: 10,
      };
      postgetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.goodListInfo = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        } else {
          this.goodListInfo = [];
          this.total = 0;
        }
      });
    },
    // 称接范围
    getCjfw() {
      var obj = {
        tableName: "tBDBearRange",
        keyWord: this.searchCon,
        parentId: ""
      };
      getkind(obj).then(data => {
        if (data.ResultCode == 1) {
          this.stylearr = data.ResultObj;
          this.stylearr.unshift({
            Id: 0,
            Name: "全部"
          });
        }
      });
    },
    // decchange() {
    //   if (this.zpflid == 0) {
    //     this.smallarr = this.jiaarr;
    //     this.zpflhxid = 0;
    //   } else if (this.zpflid == 1) {
    //     this.smallarr = this.gongarr;
    //     this.zpflhxid = 0;
    //   } else {
    //     this.smallarr = [
    //       {
    //         Id: 0,
    //         Name: "全部"
    //       }
    //     ];
    //     this.zpflhxid = 0;
    //   }
    // },
    //户型数据
    gethuxing() {
      var obj = {};
      SelectDesignerSkilledDoMainBaseData(obj).then(data => {
        if (data.ResultCode == 1) {
          for (var i = 0; i < data.ResultObj.length; i++) {
            if (data.ResultObj[i].DomainType == 0) {
              this.jiaarr.push(data.ResultObj[i]);
              this.optionshx[1].children.push({
                value: data.ResultObj[i].Id,
                label: data.ResultObj[i].Name
              });
              this.optionszpfl[1].children.push({
                value: data.ResultObj[i].Id,
                label: data.ResultObj[i].Name
              });
            } else {
              this.gongarr.push(data.ResultObj[i]);
              this.optionshx[2].children.push({
                value: data.ResultObj[i].Id,
                label: data.ResultObj[i].Name
              });
              this.optionszpfl[2].children.push({
                value: data.ResultObj[i].Id,
                label: data.ResultObj[i].Name
              });
            }
          }
        }
      });
    },
    // 户型
    handlehx(val) {
      if (val.length == 1) {
        this.decorationType = val;
        this.houseType = 0;
      } else {
        this.decorationType = val[0];
        this.houseType = val[1];
      }
    },
    // 作品分类
    handlezpfl(val) {
      if (val.length == 1) {
        this.zpflid = val;
        this.zpflhxid = 0;
      } else {
        this.zpflid = val[0];
        this.zpflhxid = val[1];
      }
    },
    // 作品名称校验
    zishu() {
      if (this.ExpName.length < 1 || this.ExpName.length > 20) {
        this.ExpName = "";
        this.showAlert('输入字数应大于1个字符小于20个字符');
      }
    },
    
    // 确定
    gonext(){
      console.log(this.companyId)
      if(this.companyId === ""){
        this.showAlert('请选择装修公司');
        return false;
      }
      this.dialogVisibleadd = false;
      this.caseing = false;
      // 获取设计师列表
      this.sjsArr=[];
      this.getsjs(this.companyId);
    },
    // 获取设计师列表
    getsjs(shopId){
      designergetlist('',shopId).then(data => {
        if(data){
          if (data.resultCode == 1) {
            this.sjsArr = data.resultObj;
            this.sjsArr.unshift({
              designerid: 0,
              designername: "请选择"
            });
          }else{
            this.sjsArr.unshift({
              designerid: 0,
              designername: "无"
            });
          }
        }else{
          this.sjsArr.unshift({
            designerid: 0,
            designername: "无"
          });
        }
      });
    },
    //新增 & 编辑
    addeditinfo(row) {
      this.listid = row.id;
      this.shopId = row.shopId;
      if(row){ // 编辑
        this.showtype = 2;
        this.caseing = false;
        // 获取设计师列表
        this.sjsArr=[];
        this.getsjs(row.shopId);
        getzxalinfo('',row.shopId,row.id).then(data => {
          if (data.resultCode == 1) {
            let thisObj = data.resultObj.info;
            this.sjsid = thisObj.designerid; // 设计师ID
            this.zpflid = thisObj.iswork; // 装修类型 0=家装 1=公装
            this.zpflhxid = thisObj.domainid; // 户型ID
            this.casaarr = [this.zpflid,this.zpflhxid]; // 作品分类
            this.zpfgid = thisObj.styleid; // 作品风格
            this.ExpSize = thisObj.expsize; // 面积
            this.ExpWorkDay = thisObj.expworkday; // 工期
            this.ExpWorkPrice = thisObj.expworkprice; // 工程造价
            this.provinceId = thisObj.provinceid; // 省
            this.cityId = thisObj.cityid; // 市
            this.selectedOptions = [this.provinceId,this.cityId]; // 所属小区
            this.ExpAddress = thisObj.expaddress; // 小区名称
            this.ExpWorkType = thisObj.expworktype; // 施工方式
            this.yezhuPhone = thisObj.phone; // 业主手机
            this.videoSrc = thisObj.videourl?localStorage.BaseOssUrl + thisObj.videourl:''; // 视频-长
            this.videoShortSrc = thisObj.videourl?thisObj.videourl:''; // 视频-短
            this.imgShopArr = data.resultObj.imgUrlList.map(item => item.replace('', localStorage.BaseOssUrl)); // 案例封面集合
            this.tableData = data.resultObj.buildingMaterialList; // 主要使用建材
            if (this.tableData.length == 1) {
              this.styleheight = "98px";
            } else if (this.tableData.length == 2) {
              this.styleheight = "138px";
            } else {
              this.styleheight = "178px";
            }
            this.changjing = thisObj.userScene; // 使 用 场 景
            this.ExpIntroduce = thisObj.expintroduce; // 案例介绍
            
            // this.detailImgUrlarr = data.ResultObj.ImgUrlList.map(item => item.replace('', localStorage.BaseOssUrl));
            // if(this.detailImgUrlarr.length == 3) {
            //   this.seeIflag = false
            // } else {
            //   this.seeIflag = true
            // }
            // if (this.zpflid == 0) {
            //   this.smallarr = this.jiaarr;
            //   this.zpflhxid = 0;
            // } else if (this.zpflid == 1) {
            //   this.smallarr = this.gongarr;
            //   this.zpflhxid = 0;
            // } else {
            //   this.smallarr = [
            //     {
            //       Id: 0,
            //       Name: "全部"
            //     }
            //   ];
            //   this.zpflhxid = 0;
            // }
            // this.ExpPrice = data.ResultObj.ExpPrice;
            // this.imageUrl = data.ResultObj.ExpTopUrl;
            // var that = this;
            // window.URL = window.URL || window.webkitURL;
            // var xhr = new XMLHttpRequest();
            // xhr.open("get", data.ResultObj.ExpTopUrl, true);
            // xhr.responseType = "blob";
            // xhr.onload = function() {
            //   //得到一个blob对象
            //   var blob = this.response;
            //   let oFileReader = new FileReader();
            //   oFileReader.onloadend = function(e) {
            //     that.imageUrl = e.target.result;
            //   };
            //   oFileReader.readAsDataURL(blob);

            //   let src = window.URL.createObjectURL(blob);
            // };
            // xhr.send();
          }
        });
      }else{ // 新增
        this.showtype = 1;
        // this.ExpName = "";
        this.firstChoice = 0;
        this.choiceBrandtype1();
        this.choiceBrand1();
        this.changjing = "";
        this.zpflid = -1;
        this.zpflhxid = 0;
        this.listid = 0;
        // this.decchange();
        this.sjsid = 0; // 设计师
        this.zpfgid = 0; // 作品风格
        this.ExpSize = "";
        this.ExpPrice = "";
        this.ExpWorkDay = "";
        this.ExpWorkPrice = "";
        this.yezhuphone = ""; // 业主手机
        this.provinceId = 0;
        this.cityId = 0;
        this.ExpAddress = "";
        this.ExpWorkType = 0;
        this.videoSrc='';
        this.imageUrl = "";
        this.detailImgUrlarr = [];
        this.flag = 0;
        this.seeIflag = true;

        this.imgShopArr = [];

        this.ExpIntroduce = "";
        this.tableData = [];
        this.casaarr = [];
        this.selectedOptions = [];
        // 获取装修公司店铺列表
        getshoplist('',localStorage.Id).then(data=>{
          if(data.resultCode == 1){
            if(data.resultObj.length>1){
              this.dialogVisibleadd = true;
              this.zxgsArr = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.companyId = data.resultObj[0].shopid; // 店铺id
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        });
      }
    },
    //保存
    emit() {
      if (!this.value2) {
        this.showAlert('请勾选并遵从原创承诺');
        return false;
      }
      // if (this.ExpName == "") {
      //   this.showAlert('请输入作品名称');
      //   return false;
      // }
      if (this.zpflid == -1) {
        this.showAlert('请选择作品分类');
        return false;
      }
      if (this.zpflhxid == 0) {
        this.showAlert('请选择作品分类');
        return false;
      }
      if (this.zpfgid == 0) {
        this.showAlert('请选择作品风格');
        return false;
      }
      if (this.ExpSize == "") {
        this.showAlert('请输入面积');
        return false;
      }
      // if (this.ExpPrice == "") {
      //   this.showAlert('请输入费用');
      //   return false;
      // }
      if (this.ExpWorkDay == "") {
        this.showAlert('请输入工期');
        return false;
      }
      if (this.ExpWorkPrice == "") {
        this.showAlert('请输入造价');
        return false;
      }
      if (this.provinceId == 0) {
        this.showAlert('请选择所属小区省份');
        return false;
      }
      if (this.cityId == 0) {
        this.showAlert('请选择所属小区城市');
        return false;
      }
      if (this.ExpAddress == "") {
        this.showAlert('请输入所属小区地址');
        return false;
      }
      if (this.ExpWorkType == 0) {
        this.showAlert('请选择施工方式');
        return false;
      }
      // if (this.yezhuPhone == "") {
      //   this.showAlert('请输入业主手机');
      //   return false;
      // }
      // if (this.imageUrl == "") {
      //   this.showAlert('请上传案例封面');
      //   return false;
      // }
      // if(this.detailImgUrlarr.length == 0){
      //   this.showAlert('请上传三张案例封面图片');
      //   return false;
      // }
      if(this.imgShopArr.length == 0){
        this.showAlert('请至少上传一张案例封面图片');
        return false;
      }
      // if (this.tableData.length == 0) {
      //   this.showAlert('请增加主要使用建材');
      //   return false;
      // }
      if (this.ExpIntroduce == "") {
        this.showAlert('请输入案例介绍');
        return false;
      }
      
      this.loading2 = true;
      var obj = {
        OperatorId: localStorage.Id,
        Id: this.listid,
        DesignerId: this.sjsid, // 设计师ID
        ShopId: this.shopId?this.shopId:this.companyId, // 店铺ID
        IsWork: this.zpflid, // 是否公装 0=家装 1=公装
        DomainId: this.zpflhxid, // 户型ID
        StyleId: this.zpfgid, // 作品风格
        ExpSize: this.ExpSize, // 面积
        ExpPrice: this.ExpWorkPrice, // 金额（与ExpWorkPrice值一样）
        ExpWorkDay: this.ExpWorkDay, // 工期
        ExpWorkPrice: this.ExpWorkPrice, // 造价
        ProvinceId: this.provinceId, // 省
        CityId: this.cityId, // 市
        ExpAddress: this.ExpAddress, // 详细地址
        ExpWorkType: this.ExpWorkType, // 施工方式ID
        phone: this.yezhuPhone, // 业主手机
        ExpIntroduce: this.ExpIntroduce, // 案例介绍
        // BuildingMaterialList: JSON.stringify(this.tableData),
        BuildingMaterialList: this.tableData,
        // ImgUrlList : this.detailImgUrlarr.map(item => item.replace(localStorage.BaseOssUrl,''))
        ImgUrlList: this.imgShopArr.map(item => item.replace(localStorage.BaseOssUrl, '')), // 展示图片集合
        videoUrl: this.videoShortSrc, // 视频（不要前缀）
      };
      postsavezxal(obj).then(data => {
        this.loading2 = false;
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.caseing = true;
          this.init();
        }
      });
    },

    // 增加使用建材
    addinfo() {
      // if (this.BrandTypeId == 0) {
      //   this.showAlert('请选择商品品类');
      //   return false;
      // }
      // if (this.BrandId == 0) {
      //   this.showAlert('请选择商品品牌');
      //   return false;
      // }
      // if (this.changjing == "") {
      //   this.showAlert('请输入使用场景');
      //   return false;
      // }
      this.tableData.push({
        brandTypeName: this.branName,
        brandName: this.branName1,
        brandId: this.BrandId,
        brandTypeId: this.BrandTypeId,
        useScene: this.changjing
      });
      if (this.tableData.length == 1) {
        this.styleheight = "98px";
      } else if (this.tableData.length == 2) {
        this.styleheight = "138px";
      } else {
        this.styleheight = "178px";
      }
      this.BrandTypeId = 0;
      this.BrandId = 0;
      this.changjing = "";
    },
    
    // 删除使用建材
    shanchu(scope) {
      this.tableData.splice(scope.$index, 1);
      if (this.tableData.length == 1) {
        this.styleheight = "98px";
      } else if (this.tableData.length == 2) {
        this.styleheight = "138px";
      } else {
        this.styleheight = "178px";
      }
      if (this.tableData.length == 0) {
        this.styleheight = "98px";
      }
    },

    // 案例封面
    beforeAvatarUpload(file) {
      const isJPG = file.type;
      if (isJPG != "image/jpeg" && isJPG != "image/png") {
        this.showAlert('上传图片格式应为jpg/png');
        return false;
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        var _this = this;
        this.flag += 1;
        if (this.flag > 3) {
          this.showAlert('最多传入3张图片');
          return false;
        }
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          // _this.imageUrl = e.target.result;
          
          // oss 直传图片
          var obj = {
            type: 33
          };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
              
            }
          })
          var newOssPic = await uploadOSS(file,0);
          _this.detailImgUrlarr.push(newOssPic);
          _this.uploadArr = 3 - _this.detailImgUrlarr.length
        };
        return file;
      },() => {
        this.showAlert('上传图片尺寸应为1200*675');
        return Promise.reject();
      });
      return isSize;
    },

    // 删除上传图片
    deldetail(val) {
      let newdetailImgUrlarr = this.detailImgUrlarr;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        if (val == i) {
          newdetailImgUrlarr.splice(i, 1);
          this.uploadArr = 3 - newdetailImgUrlarr.length
        }
      }
      this.detailImgUrlarr = newdetailImgUrlarr;
      this.flag = this.detailImgUrlarr.length;
      if(this.flag == 3) {
        this.seeIflag = false
      } else {
        this.seeIflag = true
      }
    },
    // 展示图片
    beforeUploadShopIntroduction(file) {
      const isSize = new Promise(function(resolve, reject) {
        // let width = 1200;
        // let height = 675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then( () => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {
            type: 38
          };
          getOssFile(obj).then(data => {
            this.fileName = file.name;
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.imgShopArr.push(newOssPic);
          that.imgarrCutting = newOssPic.replace(localStorage.BaseOssUrl,'')

          var obj = {
            name: this.fileName,
            url: that.imgarrCutting,
            uploader: localStorage.Id
          };
          postAddFile(obj).then(data => {
            if (data.resultCode == 1) {
              that.onePic.push(data.resultObj);
            }
          });
        };
        if (that.imgShopArr.length >= 4) {
          that.isdisabled = false;
        }
        return file;
      }, () => {
        this.showAlert('上传的图片必须是宽高比例为1:1');
        return Promise.reject();
      });
      return isSize;
    },
    // 展示图片-del
    deleteimg(index) {
      this.imgShopArr.splice(index, 1);
      this.onePic.splice(index, 1);
      if (this.imgShopArr.length >= 5) {
        this.isdisabled = false;
      } else {
        this.isdisabled = true;
      }
    },
    close() {
      this.caseing = true;
      this.init();
    },
    // 各种校验
    ExpSizeblur() {
      this.ExpPrice = this.ExpPrice.replace(/[^\d\.]/g, "").replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      );
      this.ExpSize = this.ExpSize.replace(/[^\d\.]/g, "").replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      );
      this.ExpWorkDay = this.ExpWorkDay.replace(/[^\d\.]/g, "").replace(
        ".",
        ""
      );
      this.ExpWorkPrice = this.ExpWorkPrice.replace(/[^\d\.]/g, "").replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      );
    },
    // 富文本
    beforeUpload(file) {
      // 显示loading动画
      var _this = this;
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        var obj = {
           operId: localStorage.Id,
              uploadType: 6,
         files: e.target.result //给后台传的参数 base64格式的img参数
        };
        UpoadImg(obj).then(data => {
          if (data.ResultCode == 1) {
            // 获取光标所在位置
            let length = quill.getSelection(true).index;
            // 插入图片  res.info为服务器返回的图片地址
            quill.insertEmbed(length, "image", localStorage.BaseUrl+data.ResultMsg);
            // 调整光标到最后
            quill.setSelection(length + 1);
          } else {
            this.$message({
              message: "图片上传失败!",
              type: "error"
            });
          }
        });
      };
      return file;
    },
    // 视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.showAlert('请上传小于50MB的视频');
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.showAlert('请上传mp4格式的视频');
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      let obj2 = new FormData();
      obj2.append('file',file);
      //上传视频获取路径
      uploadVedio(obj2, 5).then(data=>{
        if(data.resultCode == 1){
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8;
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'');
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.showAlert(data.resultMsg, 'error');
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      }).catch(error => {
        this.showAlert('上传失败', 'error');
      });
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
        }
      }).catch(() => {
        return;
      });
    },
    // 查询
    findinfo() {
      this.pageIndex = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 上下架
    onshop(row) {
      this.listid = row.id;
      this.isOnline = row.isOnline;
      // this.dialogVisiblesure = true;
      this.$swal({
        type: "warning",
        text:
          this.isOnline == 0
            ? "您确定上架此案例吗?"
            : "您确定下价架此案例吗?",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          this.makesure();
        }
      });
    },
    // 确定上架
    makesure() {
      var obj = {
        userId: localStorage.Id,
        id: this.listid, // 列表id
        operType: 2
      };
      EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType(obj).then( data => {
        if (data.ResultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.init();
          this.dialogVisiblesure = false;
        }
      });
    },
    // 获取风格列表
    getstyle() {
      var obj = {
        tableName: "tBD柜_风格",
        keyWord: "",
        parentId: ""
      };
      getkind(obj).then(data => {
        if (data.ResultCode == 1) {
          // this.brandList = data.ResultObj;
          this.shoptype = data.ResultObj;
          this.shoptype.unshift({
            Id: 0,
            Name: "全部"
          });
        }
      });
    },
    async choiceBrand(val) {
      if (val) {
        this.BrandId = 0;
        if (this.firstChoice == 2) {
          this.checkedbiddingId = this.BrandTypeId;
        } else {
          this.checkedbiddingId = 0;
        }
        this.brandOrType = 1;

        await this.letterDia();
      }
    },
    choiceBrand1() {
      this.BrandId = 0;
      this.brandOrType = 1;
      this.checkedbiddingId = 0;
      this.letterDia();
    },
    // 获取品类品牌
    async letterDia() {
      var obj = {
        userId: 0,
        firstLetterType: this.firstLetterType,
        brandOrType: 0,
        key: "",
        brandIdOrGoodsBrandTypeId: this.checkedbiddingId
      };
      await SelectGoodsBrandTypeByFirstLetter(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandList = data.ResultObj;
          data.ResultObj.unshift({
            Id: 0,
            Name: "请选择"
          });
          this.brandListarr = data.ResultObj;
        }
      });
    },
    letterDia1() {
      var obj = {
        userId: 0,
        firstLetterType: this.firstLetterType,
        brandOrType: 1,
        key: "",
        brandIdOrGoodsBrandTypeId: this.checkedbiddingId
      };
      SelectGoodsBrandTypeByFirstLetter(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandTypelist = data.ResultObj;
          data.ResultObj.unshift({
            Id: 0,
            Name: "请选择"
          });
        }
      });
    },
    choiceBrandtype(val) {
      if (val) {
        this.BrandTypeId = 0;

        if (this.firstChoice == 1) {
          this.checkedbiddingId = this.BrandId;
        } else {
          this.checkedbiddingId = 0;
        }
        this.brandOrType = 0;

        this.letterDia1();
      }
    },
    choiceBrandtype1() {
      this.BrandTypeId = 0;
      this.brandOrType = 0;
      this.checkedbiddingId = 0;
      this.letterDia1();
    },
    changeBrand(item) {
      if (item) {
        if (this.firstChoice == 0 || this.firstChoice == 2) {
          this.firstChoice = 2;
          this.checkedbiddingId = 0;
        }
        if (this.firstChoice == 1) {
          this.checkedbiddingId = this.BrandId;
        }
      }
      //    for(var i = 0;i<this.brandTypelist.length;i++){
      //      if( this.brandTypelist[i].Id = item){

      //      }
      //    }
      for (var i = 0; i < this.brandTypelist.length; i++) {
        if (this.brandTypelist[i].Id == item) {
          this.branName = this.brandTypelist[i].Name;
        }
      }
    },
    changeBra(item) {
      if (this.firstChoice == 0 || this.firstChoice == 1) {
        this.firstChoice = 1;
        this.checkedbiddingId = 0;
      }
      if (this.firstChoice == 2) {
        this.checkedbiddingId = this.BrandTypeId;
      }

      for (var i = 0; i < this.brandList.length; i++) {
        if (this.brandList[i].Id == item) {
          this.branName1 = this.brandList[i].Name;
        }
      }
    },
    
    // 请选择省市
    handlesscs(val) {
      this.provinceId = val[0]; // 省
      this.cityId = val[1]; // 市
    },
    // 查找省市
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        that.optionssscs = provinceAndCityAndarea;
      })
    },
    // 所属店铺
    suoshudianpu(){
      let obj = {
        userId:localStorage.Id,
        dcName:"",
        shoptyp: 2,
      }
      userIdentity(obj).then(data=>{
        if(data.resultCode == 1){
          this.dianpuArr = data.resultObj;
          this.dianpuArr.unshift({
            id: 0,
            name: "全部"
          });
        }
      })
    },
  },
  created() {
    this.init();
    this.suoshudianpu(); // 所属店铺
    this.gethuxing();
    this.getprovince(); // 所属小区
    this.getstyle(); // 获取风格列表
    this.getCjfw(); // 称接范围
  }
};
</script>
<style scoped>
.domDiv {
  width: 93%;
  margin: 0 auto;
  padding-bottom: 30px;
}
.leftspan {
  font-size: 18px;
  font-weight: 600;
}
.ahref {
  color: #040404;
}
.ahref:hover {
  color: #F56C6C;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eee;
  text-align: center;
  margin-right: 10px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.rideo {
  display: inline-block;
  height: 5px;
  width: 5px;
  background: #bcbbba;
  border-radius: 50%;
  margin-left: 12px;
  margin-right: 12px;
}
.contentDiv {
  width: 93%;
  margin: 0 auto;
}
.xmxx {
  font-size:16px;
  font-weight:600;
  margin-left:10px;
}
.demoFormInline {
  width: 100%;
  display:flex;
  flex: 1;
}
.selectflex {
  width: 50%;
  margin-top:10px;
  display:flex;
}
.youwo {
  width: 80%;
  display: flex;
}
.youwo>span {
  margin-right:10px;
}
.youwo>p {
  font-size:15px;
  margin-top: 0px;
}
.multigraph {
  width: 100px;
  height: 60px;
  position: relative;
  float:left;
  margin-right:10px;
  border: 1px solid #fff;
}
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -5px;
  top: -5px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// decorationCases.vue?35a6e099